import { MMKV } from 'react-native-mmkv';

export interface PartnerChecklistBaseline {
  revision: number;
  touched: boolean;
  active: boolean;
  enabled: boolean;
}

let storage: MMKV | undefined;
const db = () => storage ??= new MMKV({ id: 'partner-checklist-baseline-v1' });
const key = (companyId: string, userId: string, checklistId: string) =>
  JSON.stringify([companyId, userId, checklistId]);

/** Revisão da leitura incorporada ao editor, nunca da consulta feita durante o envio. */
export const readPartnerChecklistBaseline = (companyId: string, userId: string, checklistId: string): PartnerChecklistBaseline | null => {
  try {
    const raw = db().getString(key(companyId, userId, checklistId));
    const value = raw ? JSON.parse(raw) : null;
    return value && Number.isSafeInteger(value.revision) && value.revision >= 0 ? value : null;
  } catch { return null; }
};

export const savePartnerChecklistBaseline = (
  companyId: string, userId: string, checklistId: string, value: PartnerChecklistBaseline,
): void => {
  if (!companyId || !userId || !checklistId || !Number.isSafeInteger(value.revision) || value.revision < 0) {
    throw new Error('Identidade ou revisão do checklist inválida.');
  }
  db().set(key(companyId, userId, checklistId), JSON.stringify({
    revision: value.revision, touched: value.touched === true,
    active: value.active === true, enabled: value.enabled === true,
  }));
};
